import type { ProductListItemFragment } from "@/gql/graphql";
import type { PeptideProductCardData } from "./peptide-product-card";
import type { ProductCardData } from "@/ui/components/plp/product-card";
import { transformToProductCard } from "@/ui/components/plp/utils";
import { hasPeptideMetadata, parsePeptideMetadata } from "@/lib/peptide-metadata";
import { metafieldsToEntries } from "@/lib/product-card-metadata";

/**
 * Transform Saleor product to PeptideProductCardData (includes peptide metadata).
 */
function transformToPeptideCard(product: ProductListItemFragment, channel: string): PeptideProductCardData {
	const base = transformToProductCard(product, channel);
	const peptideMetadata = parsePeptideMetadata(metafieldsToEntries(product.metafields));

	return {
		...base,
		peptideMetadata,
	};
}

/**
 * Transform Saleor product to ProductCardData or PeptideProductCardData.
 * Uses PeptideProductCard when product has peptide metadata.
 */
export function transformToProductOrPeptideCard(
	product: ProductListItemFragment,
	channel: string,
): ProductCardData | PeptideProductCardData {
	if (hasPeptideMetadata(metafieldsToEntries(product.metafields))) {
		return transformToPeptideCard(product, channel);
	}
	return transformToProductCard(product, channel);
}
